import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useMatch } from "react-router-dom";
import WriteLog from "./Globals/WriteLog";

export default function SideBarItem({ name, description, Icon, routing, hero, trigger, addrSeq }) {    
    const match = useMatch(routing+"/:id")        
    
    //uncheck the all location checkbox
    if(match?.params?.id != -1)
        if(trigger !=null)
            trigger(false);

    WriteLog("SideBarItem->routing", routing)
    WriteLog("SideBarItem->addrSeq", addrSeq)
    WriteLog("SideBarItem->match?.params?.id", match?.params?.id)

    
            
    return (
        <Link to={routing+"/"+addrSeq } >            
            <div className="flex items-center m-3 p-1 cursor-pointer hover:bg-gray-300 rounded-xl">
                <div className="flex h-9 w-9 shrink-0 grow-0 items-center justify-center rounded-full bg-gray-200 cursor-pointer">

                    {hero && 
                    <Icon className="w-5 h-5 text-orange-300" />
                    }
                    {!hero && 
                    <FontAwesomeIcon icon={Icon} className="w-5 h-5 text-slate-400"/>
                    }                     
                </div>                
                <div>
                    <div>
                        <div className="px-3 text-black text-[11pt] ">{name}</div>
                    </div>
                    <div>
                        <div className="px-3 text-gray-500 text-[9pt] italic">{description}</div>
                    </div>
                </div>
            </div>
        </Link>        
    )
}